import Daun from '../../../assets/images/s1_daun.png'
import Picture from '../../../assets/images/s1_picture.png'
import MockupPhone from '../../../assets/images/s1_mocup_phone.png'
import { FaArrowRight } from 'react-icons/fa'


const Section1 = () => {
    return (
        <div id='home' className="w-full">
            <div className='w-full flex flex-col items-center justify-center pt-20 md:pt-20' >
                <div className='flex flex-col items-center justify-center relative  text-center'>
                    <h1 className='text-custom-green text-4xl md:text-[110px] uppercase font-bold'>KEBUN JITU</h1>
                    <p className='md:pt-10'>
                        {/* To help horticulture farmers thrive by making precision agriculture simple and accessible */}
                        Analisa tanah instant dan akurat di lahan anda
                    </p>
                    <img src={MockupPhone} alt="Kebun Jitu" className='absolute scale-50 md:scale-75 -top-8 right-0 md:-right-32 h-full object-contain hidden md:block ' loading='lazy' />
                </div>
            </div>
            <img src={Daun} alt="Kebun Jitu" className='absolute left-0 w-[100px] md:w-[300px] object-contain -scale-x-100 z-10' loading='lazy' />
            <img src={Daun} alt="Kebun Jitu" className='absolute right-0 w-[100px] md:w-[300px] object-contain z-10' loading='lazy' />
            <div className='relative flex items-center justify-center mt-16 md:mt-10'>
                <img src={Picture} alt="Kebun Jitu" className='w-[90%] md:w-[70%] object-contain mx-auto' loading='lazy' />
                <button type='button' className='absolute text-white flex items-center justify-center gap-2 font-semibold'>
                    <span className='bg-custom-orange rounded-full px-5 py-2'>Get Started</span>
                    <div className='rounded-full bg-custom-orange h-10 aspect-square flex items-center justify-center'>
                        <FaArrowRight />
                    </div>
                </button>
            </div>
        </div>
    )
}

export default Section1